import { SelectOption } from "PFTypes/selector";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

type UseSupplyTotalDemandSelectorsReturn = {
  sortOptions: Record<string, string>;
  barsOptions: Record<string, string>;
  topNumberOptions: SelectOption[];
  sortByOptions: SelectOption[];
};

export const useSupplyTotalDemandSelectors = (): UseSupplyTotalDemandSelectorsReturn => {
  const { t } = useTranslation("insights");

  const sortOptions = useMemo(
    () => ({
      "supply-all": t("filters.supplyAll"),
      "supply-developmental": t("filters.supplyDevelopmental"),
      "supply-rare": t("filters.supplyRare"),
      "supply-core": t("filters.supplyCore"),
      "demand": t("filters.demand"),
      "gaps": t("filters.gaps")
    }),
    []
  );

  const barsOptions = useMemo(
    () => ({
      rare: t("supplyRare"),
      top: t("supplyCore"),
      developmental: t("supplyDevelopmental"),
      all: t("supplyAll"),
      demand: t("filters.demand")
    }),
    []
  );

  const topNumberOptions = useMemo(
    () =>
      ["25", "50", "100"].map((item) => ({
        id: item,
        displayElement: <span>{item}</span>,
        item: item
      })),
    []
  );

  const sortByOptions = Object.keys(sortOptions).map((item) => ({
    id: item,
    displayElement: <span>{sortOptions[item]}</span>,
    item: item
  }));

  return {
    sortOptions,
    barsOptions,
    topNumberOptions,
    sortByOptions
  };
};
